import moment from 'moment'

/*
    Проверка на истечение срока
    expData - проверяемая дата
    endOfDay - флаг проверки "До конца дня истечения срока"
*/
export const isExpired = (expData: string | Date, endOfDay: boolean = false): boolean => {
    if (endOfDay) {
        return moment().isAfter(moment(expData).endOf('day'));
    } else {
        return moment().isAfter(moment(expData))
    }
}

// Получение дней до истечения
export const getDaysRemaining = (expData: string | Date): number => {
    const days = moment(expData).diff(moment(), 'days')
    return Math.max(0, days)
}

// Проверка на вывод предупреждение о скором истечении
export const shouldWarn = (expData: string | Date, daysBefore: number = 30): boolean => {
    const remaining = getDaysRemaining(expData)
    return remaining > 0 && remaining <= daysBefore;
}